import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const UserWallet = ()=>{
    const [userWallet, setUserWallet] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`userWallet?page=${page}`);
            setUserWallet(data.data);
            setLastPage(data.meta.last_page)
            console.log(data.data);

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`userWallet/${id}`);
            setUserWallet(userWallet.filter((userWallet) => userWallet.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'UserWallet'}>
            <InnerNav createLink={'/userWalletCreate'} listLink={'/userWallet'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">User </th>
                                    <th className="px-4 py-3">BookBalance </th>
                                    <th className="px-4 py-3">AvailableBalance </th>
                                    <th className="px-4 py-3">DateLastWithdrawal </th>
                                    <th className="px-4 py-3">AmountLastWithdrawal </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                {userWallet && userWallet.length > 0 ? (
                                    userWallet.map((wallet) => (
                                        <tr key={wallet.id} className="text-gray-700 dark:text-gray-400">
                                            <td className="px-4 py-5">{wallet.id}</td>
                                            <td className="px-4 py-3 text-sm">{wallet.user.first_name + " " + wallet.user.last_name}</td>
                                            <td className="px-4 py-3 text-sm">{wallet.book_balance}</td>
                                                 <td className="px-4 py-3 text-sm">{wallet.available_balance}</td>
                                                 <td className="px-4 py-3 text-sm">{wallet.date_last_withdrawal}</td>
                                                 <td className="px-4 py-3 text-sm">{wallet.amount_last_withdrawal}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/userWallet/${wallet.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(wallet.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                          
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="px-4 py-3 text-sm text-center">
                                                No wallet data available.
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default UserWallet;